import React, {useState} from 'react';
import RecoveryPasswordRequestForm from "./RecoveryPasswordRequestForm/RecoveryPasswordRequestForm";


const RecoveryPasswordRequest = () => {


    const [isSent, setIsSent] = useState<boolean>(false)


    return (
        <div>
            {isSent
            ? <p>На вашу эл. почту было отправленно пиьсмо с ссылкой на восстановление пароля!</p>
            : <RecoveryPasswordRequestForm setIsSent={setIsSent}/>}
        </div>

    );
};

export default RecoveryPasswordRequest;